import { createReducer } from '@reduxjs/toolkit';
import { awsInit } from './init';
import { requestCheckObject, requestCheckObjectSuccess, requestCheckObjectFailure } from '../actions/aws/actions';

const aws = createReducer(awsInit, {
  [requestCheckObject.type]: (state) => {
    state.exist = false;
    state.isLoading = true;
  },
  [requestCheckObjectSuccess.type]: (state, action) => {
    const { exist } = action.payload;
    state.exist = exist;
    state.isLoading = false;
  },
  [requestCheckObjectFailure.type]: (state) => {
    state.exist = false;
    state.isLoading = false;
  }
})

export default aws;
